import { inject, Injectable } from '@angular/core';
import { SitesService } from 'shared/services';
import { filter, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContextService } from 'core/services/context.service';

@Injectable()
export class FreightTypesFilterViewModel {
  private sitesService = inject(SitesService);
  private contextService = inject(ContextService);
  public freightTypesData$ = this.contextService.siteId.asObservable().pipe(
    filter((siteId) => siteId !== null),
    switchMap((siteId) => this.sitesService.getFreightTypes(siteId)),
    map(({ value }) => value.freightTypes.map((type) => ({ ...type, deleted: type.deleted ?? false })))
  );
}
